import { Toggle } from "../../../shared/components/Toggle";
import { track } from "../../tracker/EventTracker";

customElements.define(
	"esc-hotel-search-toggle",
	class extends Toggle {
		open() {
			track("Hotel", "Klick Suche", "Oeffnen");
			super.open();
		}

		close() {
			track("Hotel", "Klick Suche", "Schließen");
			super.close();
		}
	},
);
